export default __webpack_public_path__ + "static/media/util.edea3010.svg";